import { Role } from '../../types'

const EXECUTIVE_COMMISSION_LIQUIDATOR_ROLES = new Set<Role>([Role.admin, Role.procesos])

const canLiquidateExecutiveCommissions = (role: Role) => EXECUTIVE_COMMISSION_LIQUIDATOR_ROLES.has(role)
const canDeleteExecutiveCommissionSettlements = (role: Role) => role === Role.admin

const canViewExecutiveCommissions = (role: Role) => role === Role.ejecutivo || canLiquidateExecutiveCommissions(role)

export { canDeleteExecutiveCommissionSettlements, canLiquidateExecutiveCommissions, canViewExecutiveCommissions }
